import React from 'react'
import IntlTelInput from 'intl-tel-input/react'
import PropTypes from 'prop-types'
import 'intl-tel-input/build/css/intlTelInput.css'
import './styles.scss'

const PhoneInput = ({
  name,
  labelColor,
  labelFontSize,
  globalSettings,
  field,
  formatMessage,
  settings,
  serverRender,
  inputStyleProp = {},
  labelStyleProp = {},
  inputClassName,
}) => {
  const inputStyles = {
    width: '100%',
    padding: '0px 10px 0px 52px',
    height: `${settings.fields_height}px`,
    lineHeight: `${settings.fields_height}px`,
    borderWidth: `${settings.fields_borderWidth}px`,
    borderRadius: `${settings.fields_borderRadius}px`,
    borderColor: settings.fields_borderColor,
    borderStyle: 'solid',
    background: settings.fields_background,
    color: settings.fields_color,
    fontSize: `${globalSettings.normalText_fontSize}px`,
    fontFamily: globalSettings.normalText_fontFamily,
    ...inputStyleProp,
  }

  const initOptions = {
    initialCountry: 'se',
    containerClass: 'phone-number-container',
    utilsScript:
      'https://cdn.jsdelivr.net/npm/intl-tel-input@21.1.3/build/js/utils.js',
    dropdownContainer: serverRender ? undefined : window.document.body,
    hiddenInput: function () {
      return {
        phone: 'sms_number',
        country: 'country_code',
      }
    }
  }

  return (
    <div
      style={{ marginBottom: '10px' }}
              data-name={name}
        data-testid={name}
      data-init-options={btoa(JSON.stringify(initOptions))}
      className={`gan-validate gan-field gan-field-${field.name} ${
        field.required ? `gan-validate-required${!inputClassName ? '' : ' gan-field-required'}` : ''
      }`}
    >
      <label
        style={{
          color: labelColor,
          fontSize: `${labelFontSize}px`,
          lineHeight: globalSettings.normalText_lineHeight,
          fontFamily: globalSettings.normalText_fontFamily,
          maxWidth: '250px',
          whiteSpace: 'nowrap',
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...labelStyleProp,
        }}
      >
        {(field.default || typeof field.default === 'undefined') &&
        (!field.label || field.label === field.defaultLabel)
          ? formatMessage(field.defaultLabel)
          : field.label}
        {field.required && !inputClassName ? <span>*</span> : null}
      </label>

      <IntlTelInput
        name={name}
        disabled={!serverRender}
        inputProps={{
          style: inputStyles,
          required: field.required,
          className: inputClassName,
        }}
        preferredCountries={['se', 'us']}
        initOptions={initOptions}
      />
      <div
        className="gan-validation-error gan-validation-field-error"
        style={{
          color: 'red',
          fontSize: `${globalSettings.normalText_fontSize * 0.7}px`,
        }}
      />
    </div>
  )
}

PhoneInput.propTypes = {
  name: PropTypes.string,
  labelColor: PropTypes.string,
  labelFontSize: PropTypes.string,
  globalSettings: PropTypes.shape({
    normalText_lineHeight: PropTypes.string,
    normalText_fontFamily: PropTypes.string,
    normalText_fontSize: PropTypes.string,
  }),
  field: PropTypes.shape({
    default: PropTypes.any,
    defaultLabel: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
  }).isRequired,
  formatMessage: PropTypes.func,
  settings: PropTypes.shape({
    fields_height: PropTypes.string,
    fields_borderWidth: PropTypes.string,
    fields_borderRadius: PropTypes.string,
    fields_borderColor: PropTypes.string,
    fields_background: PropTypes.string,
    fields_color: PropTypes.string,
  }),
  serverRender: PropTypes.bool,
  inputStyleProp: PropTypes.object,
  labelStyleProp: PropTypes.object,
}

export default PhoneInput
